export const QUERY_KEYS = {
  CALCULATION_RESULT: "calculation-results",
  PRICE: "price",
  SESSION: "session",
  TARIFFS: "tariffs",
  OPERATORS: "operators",
  FORM_STEP: "form",
  CUSTOMER: "customer",
};
